const clientSide = typeof window !== 'undefined';
const isMobileDevice = () => {
  if (!clientSide) return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export { clientSide, isMobileDevice };
